import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getMemberAddress } from '../services/address'
import ActionType from '../../../redux/reducer/globalActionType';

const setAddressCheck = (setting) => ({
  type: ActionType.SET_ADDR_CHECK,
  payload: setting
});

const useMemberAddressData = (params) => {
  const dispatch = useDispatch();
  const { idMember, username, token, addrcheck: addressCheck } = useSelector(state => state)
  const queryKey = useMemo(() => ['useMemberAddressData', idMember, username, params], [idMember, username, params])

  return useQuery({
    queryKey: queryKey,
    queryFn: () => getMemberAddress({ params, token }),
    cacheTime: 1000 * 60 * 60, // 1 jam
    staleTime: 1000 * 60 * 60, // 1 jam
    refetchOnWindowFocus: false,
    retry: 1,
    enabled: !!idMember && !!token,
    onSuccess: (data) => {
      const { isaddrexists: isAddressExists } = addressCheck;
      if (data.results.length > 0) {
        if (!isAddressExists) {
          return dispatch(setAddressCheck({
            ...addressCheck,
            isaddrexists: true,
          }));
        }
      }
      return dispatch(setAddressCheck({
        ...addressCheck,
        isaddrexists: undefined,
        hidalerttime: undefined,
        ishidalert: undefined,
      }));
    },
  });
}

export default useMemberAddressData